/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetListTemplatesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetListTemplatesQuery = {
  __typename?: 'Query',
  listTemplates?: Array<{
    __typename?: 'TemplateSet',
    id?: number | null,
    name: string,
    preferredLanguage?: {
      __typename?: 'Language',
      id: number,
      description: string,
      code: string
    } | null
  }> | null
};

export type GetCargoTemplatesQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.CargoTemplateSearch>;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetCargoTemplatesQuery = {
  __typename?: 'Query',
  cargoTemplates: {
    __typename?: 'CargoTemplatePage',
    totalElements: number,
    content?: Array<{
      __typename?: 'CargoTemplate',
      id: number,
      templateDescription?: string | null
    }> | null
  }
};

export type GetAgreementTemplatesQueryVariables = Types.Exact<{
  pagination: Types.Pagination;
  search: Types.AgreementsTemplateSearch;
}>;


export type GetAgreementTemplatesQuery = {
  __typename?: 'Query',
  agreementTemplates: {
    __typename?: 'AgreementsTemplatePage',
    totalElements: number,
    content?: Array<{
      __typename?: 'AgreementsTemplate',
      id: number,
      compatibleCharterType: Types.CharterType,
      compatibleCharterSubtype: Types.CharterSubtype,
      description?: string | null,
      isDefault: boolean,
      agreements: Array<{
        __typename?: 'AddressCommissionAgreement',
        id: number
      } | {
        __typename?: 'BlockFreightAgreement',
        id: number
      } | {
        __typename?: 'BunkerAdjustmentAgreement',
        id: number
      } | {
        __typename?: 'CleaningAgreement',
        id: number
      } | {
        __typename?: 'CommissionAgreement',
        id: number
      } | {
        __typename?: 'DailyAgreement',
        id: number
      } | {
        __typename?: 'DangerousGoodAgreement',
        id: number
      } | {
        __typename?: 'DeadfreightAgreement',
        id: number
      } | {
        __typename?: 'DemurrageAgreement',
        id: number
      } | {
        __typename?: 'DemurrageCalculationAgreement',
        id: number
      } | {
        __typename?: 'FeetAgreement',
        id: number
      } | {
        __typename?: 'FreightAgreement',
        id: number
      } | {
        __typename?: 'GasolineAgreement',
        id: number
      } | {
        __typename?: 'GasolinePriceAgreement',
        id: number
      } | {
        __typename?: 'HoseRentalAgreement',
        id: number
      } | {
        __typename?: 'HourlyAgreement',
        id: number
      } | {
        __typename?: 'LumpsumAgreement',
        id: number
      } | {
        __typename?: 'MultiCargoAdjustmentAgreement',
        id: number
      } | {
        __typename?: 'MultiOrderAdjustmentAgreement',
        id: number
      } | {
        __typename?: 'NitrogenPurgingAgreement',
        id: number
      } | {
        __typename?: 'OogAgreement',
        id: number
      } | {
        __typename?: 'PJKAgreement',
        id: number
      } | {
        __typename?: 'PostCalculationAgreement',
        id: number
      } | {
        __typename?: 'ReeferAgreement',
        id: number
      } | {
        __typename?: 'RentAgreement',
        id: number
      } | {
        __typename?: 'ReturnFreightDiscountAgreement',
        id: number
      } | {
        __typename?: 'ShipAgreement',
        id: number
      } | {
        __typename?: 'SupplementaryHeatingAgreement',
        id: number
      } | {
        __typename?: 'TeuAgreement',
        id: number
      } | {
        __typename?: 'TextAgreement',
        id: number
      } | {
        __typename?: 'WaterLevelAgreement',
        id: number
      } | {
        __typename?: 'WaterwayAgreement',
        id: number
      } | {
        __typename?: 'WeightAgreement',
        id: number
      } | {
        __typename?: 'WeightRangeAgreement',
        id: number
      }>
    }> | null
  }
};

export type GetDefaultTemplateByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetDefaultTemplateByIdQuery = {
  __typename?: 'Query',
  getById: {
    __typename?: 'TemplateSet',
    id?: number | null,
    name: string,
    version?: string | null,
    preferredLanguage?: {
      __typename?: 'Language',
      id: number,
      code: string,
      description: string
    } | null,
    latestTemplates: Array<{
      __typename?: 'Template',
      id?: number | null,
      template: string,
      version?: string | null,
      isFinal: boolean,
      subject?: string | null,
      name: string,
      created: number,
      templateSet?: {
        __typename?: 'TemplateSet',
        id?: number | null,
        name: string
      } | null,
      language: {
        __typename?: 'Language',
        id: number,
        code: string,
        description: string
      }
    }>
  }
};

export type GetDefaultTemplateByNameQueryVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type GetDefaultTemplateByNameQuery = {
  __typename?: 'Query',
  getByName: {
    __typename?: 'TemplateSet',
    id?: number | null,
    name: string,
    version?: string | null,
    preferredLanguage?: {
      __typename?: 'Language',
      id: number,
      code: string,
      description: string
    } | null,
    latestTemplates: Array<{
      __typename?: 'Template',
      id?: number | null,
      template: string,
      version?: string | null,
      isFinal: boolean,
      subject?: string | null,
      name: string,
      created: number,
      templateSet?: {
        __typename?: 'TemplateSet',
        id?: number | null,
        name: string
      } | null,
      language: {
        __typename?: 'Language',
        id: number,
        code: string,
        description: string
      }
    }>
  }
};

export type GetTemplateVersionsByNameAndLanguageCodeQueryVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  languageCode: Types.Scalars['String']['input'];
  pagination: Types.Pagination;
}>;


export type GetTemplateVersionsByNameAndLanguageCodeQuery = {
  __typename?: 'Query',
  templateVersionsByNameAndLanguageCode: {
    __typename?: 'TemplatePage',
    totalElements: number,
    content: Array<{
      __typename?: 'Template',
      id?: number | null,
      template: string,
      version?: string | null,
      isFinal: boolean,
      subject?: string | null,
      name: string,
      created: number,
      templateSet?: {
        __typename?: 'TemplateSet',
        id?: number | null,
        name: string
      } | null,
      language: {
        __typename?: 'Language',
        id: number,
        code: string,
        description: string
      }
    }>
  }
};


export const GetListTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLanguage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetListTemplatesQuery, GetListTemplatesQueryVariables>;
export const GetCargoTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCargoTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CargoTemplateSearch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargoTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateDescription"}}]}}]}}]}}]} as unknown as DocumentNode<GetCargoTemplatesQuery, GetCargoTemplatesQueryVariables>;
export const GetAgreementTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgreementTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgreementsTemplateSearch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleCharterType"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleCharterSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}}]} as unknown as DocumentNode<GetAgreementTemplatesQuery, GetAgreementTemplatesQueryVariables>;
export const GetDefaultTemplateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultTemplateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"templateSet"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"templateSet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateSet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLanguage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"template"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"template"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isFinal"}},{"kind":"Field","name":{"kind":"Name","value":"templateSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]} as unknown as DocumentNode<GetDefaultTemplateByIdQuery, GetDefaultTemplateByIdQueryVariables>;
export const GetDefaultTemplateByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultTemplateByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getByName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"templateSet"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"templateSet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateSet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLanguage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"template"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"template"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isFinal"}},{"kind":"Field","name":{"kind":"Name","value":"templateSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]} as unknown as DocumentNode<GetDefaultTemplateByNameQuery, GetDefaultTemplateByNameQueryVariables>;
export const GetTemplateVersionsByNameAndLanguageCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTemplateVersionsByNameAndLanguageCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateVersionsByNameAndLanguageCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"template"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"template"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isFinal"}},{"kind":"Field","name":{"kind":"Name","value":"templateSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]} as unknown as DocumentNode<GetTemplateVersionsByNameAndLanguageCodeQuery, GetTemplateVersionsByNameAndLanguageCodeQueryVariables>;